import { useMemo, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button as Button } from '@factorialco/f0-react'
import { Plus } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ApprovalSettingsModal } from './ApprovalSettingsModal'
import { StrategiesDisplay } from './StrategiesDisplay'
import { StrategyItem, StrategyType } from './utils/interfaces'

interface ApproverSelectionContainerProps {
  strategies: StrategyItem[]
  unselectableStrategies?: StrategyType[]
  onAddStrategies: (strategies: StrategyItem[]) => void
  onDeleteStrategy: (strategyId: string) => void
  unselectableEmployees?: Array<number>
  unselectableTeams?: Array<number>
  unselectableRoles?: Array<number | string>
  entityName: string
  maxStrategies?: number
}

export const ApproverSelectionContainer = ({
  strategies,
  unselectableStrategies = [],
  onAddStrategies,
  onDeleteStrategy,
  unselectableEmployees = [],
  unselectableTeams = [],
  unselectableRoles = [],
  entityName,
  maxStrategies = Number.POSITIVE_INFINITY,
}: ApproverSelectionContainerProps) => {
  const { company } = useCurrentSession()

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Box gap="s8" width="full">
      <Box gap="s2" width="full">
        <StrategiesDisplay strategies={strategies} onDeleteStrategy={onDeleteStrategy} />
      </Box>

      {strategies.length < maxStrategies && (
        <Box flexDirection="row" justifyContent="flexStart" width="full" paddingTop="s8">
          <Button
            icon={Plus}
            label={i18n.t('workflows.sidepanel.approval.add_approvers.title_with_entity', {
              entityName,
            })}
            onClick={() => setIsModalOpen(true)}
            size="md"
            variant="outline"
          />
        </Box>
      )}

      <ApprovalSettingsModal
        entityName={entityName}
        isOpen={isModalOpen}
        onAddStrategies={onAddStrategies}
        onClose={() => setIsModalOpen(false)}
        strategies={strategies}
        unselectableEmployees={unselectableEmployees}
        unselectableRoles={unselectableRoles}
        unselectableStrategies={unselectableStrategies}
        unselectableTeams={unselectableTeams}
      />
    </Box>
  )
}
